import { ArrowTrendingUpIcon, BanknotesIcon, SparklesIcon } from "@heroicons/react/24/outline";
import AffiliateLevelsModal from "./AffiliateLevelsModal";
import { formatCurrency } from "../lib/affiliateAnalytics";
import { useState } from "react";

export default function Navbar({ user, analytics, loading }) {
  const [showAffiliateLevelsModal, setShowAffiliateLevelsModal] = useState(false);

  const totals = analytics?.totals;
  const level = analytics?.level;

  return (
    <header className="sticky top-0 z-20 border-b border-white/10 bg-[rgba(7,12,21,0.75)] backdrop-blur-xl">
      <div className="flex flex-col gap-4 px-4 py-4 md:px-8">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <div className="text-xs uppercase tracking-[0.28em] text-[var(--aff-muted)]">
              Affiliate command center
            </div>
            <h1 className="mt-1 text-2xl font-black text-white">
              Track registrations, turnover, and commission in one place
            </h1>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            <button
              type="button"
              onClick={() => setShowAffiliateLevelsModal(true)}
              className="inline-flex items-center gap-2 rounded-2xl border border-emerald-400/25 bg-emerald-400/12 px-4 py-2 text-sm font-semibold text-emerald-100"
            >
              <SparklesIcon className="h-4 w-4" />
              {loading ? "Loading level..." : `Level ${level?.level || 1}`}
            </button>
            <div className="rounded-2xl border border-white/10 bg-white/[0.05] px-4 py-2 text-sm text-slate-300">
              {user?.email}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
          <MetricPill
            icon={BanknotesIcon}
            label="Available balance"
            value={loading ? "..." : formatCurrency(totals?.balance)}
          />
          <MetricPill
            icon={ArrowTrendingUpIcon}
            label="Turnover share"
            value={loading ? "..." : formatCurrency(totals?.totalVolShare)}
            hint={loading ? "" : `${((totals?.turnoverRate || 0) * 100).toFixed(1)}% level rate`}
          />
          <MetricPill
            icon={SparklesIcon}
            label="All-time commission"
            value={loading ? "..." : formatCurrency(totals?.totalCommission)}
            hint={loading ? "" : `${totals?.registrations || 0} referred players`}
          />
        </div>
      </div>

      <AffiliateLevelsModal
        open={showAffiliateLevelsModal}
        onClose={() => setShowAffiliateLevelsModal(false)}
        currentLevel={level?.level || 1}
        currentDeposits={totals?.depositsCount || 0}
      />
    </header>
  );
}

function MetricPill({ icon: Icon, label, value, hint = "" }) {
  return (
    <div className="rounded-3xl border border-white/10 bg-white/[0.04] px-4 py-3">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-white/10">
          <Icon className="h-5 w-5 text-emerald-300" />
        </div>
        <div className="min-w-0">
          <div className="text-xs uppercase tracking-[0.18em] text-[var(--aff-muted)]">{label}</div>
          <div className="truncate text-lg font-bold text-white">{value}</div>
          {hint ? <div className="text-xs text-slate-400">{hint}</div> : null}
        </div>
      </div>
    </div>
  );
}
